export class DateHelper {
  public static onSameDay(x: Date, y: Date): boolean {
    x = new Date(x);
    y = new Date(y);

    return x.getDate() == y.getDate()
      && x.getFullYear() == y.getFullYear()
      && x.getMonth() == y.getMonth();
  }

  public static isToday(x: Date): boolean {
    const now = new Date();

    return x.getDate() == now.getDate()
      && x.getFullYear() == now.getFullYear()
      && x.getMonth() == now.getMonth();
  }

  /**
   * https://stackoverflow.com/questions/1181219/determine-if-a-date-is-a-saturday-or-a-sunday-using-javascript
   * @param date
   */
  public static isWeekendDay(date: Date): boolean {
    return !(new Date(date).getDay() % 6);
  }

  public static firstAndLastDaysOfCurrentWeek(): { firstDay: Date, lastDay: Date } {
    const today = new Date();
    const firstWeekDay = new Date(today.setDate(today.getDate() - today.getDay() + 1));
    const lastWeekDay = new Date(today.setDate(today.getDate() - today.getDay() + 7));

    return {lastDay: lastWeekDay, firstDay: firstWeekDay};
  }

  public static firstAndLastDaysOfCurrentMonth(): { firstDay: Date, lastDay: Date } {
    const now = new Date();

    return {
      firstDay: new Date(now.getFullYear(), now.getMonth(), 1),
      lastDay: new Date(now.getFullYear(), now.getMonth() + 1, 0)
    };
  }

  public static firstAndLastDaysOfCurrentYear(): { firstDay: Date, lastDay: Date } {
    const now = new Date();

    return {
      firstDay: new Date(now.getFullYear(), 0, 1),
      lastDay: new Date(now.getFullYear(), 11, 31)
    };
  }

  public static getAllDatesBetween(firstDate: Date, lastDate: Date): Date[] {
    const date = new Date(firstDate.getTime());
    const endDate = new Date(lastDate.getTime());
    const dates = [];

    // Normaliser les heures pour éviter les problèmes de comparaison
    date.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    while (date <= endDate) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }

    return dates;
  }

  public static getNumberOfDaysBetween(firstDate: Date, lastDate: Date) : number {
    const oneDay = 86400000;
    const differenceInMilliseconds = Math.abs(firstDate.getTime() - lastDate.getTime());
    return Math.round(differenceInMilliseconds / oneDay) + 1;
  }

  public static isDateBetween(date: Date, dates: {start: Date, end: Date}): boolean {
    return (new Date(dates.start).setHours(0,0,0,0) <= date.getTime())
      && (new Date(dates.end).setHours(23,59,59,999) >= date.getTime());
  }
}
